module.exports = __webpack_public_path__ + "img/im_scrollfeature_12@2x.da59b78f.jpg";